(function () {
  'use strict';

  function initReveal(root) {
    if (!root || root.dataset.eppRevealReady) return;
    root.dataset.eppRevealReady = '1';
    var nodes = root.querySelectorAll('.epp-reveal');
    if (!nodes.length) return;
    if (!('IntersectionObserver' in window)) {
      nodes.forEach(function (el) { el.classList.add('epp-vis'); });
      return;
    }
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('epp-vis');
          io.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
    );
    nodes.forEach(function (el) { io.observe(el); });
  }

  function initHeroVideo(root) {
    if (!root) return;
    var video = root.querySelector('.epp-hero-video');
    if (!video) return;
    var source = video.querySelector('source');
    var src = video.getAttribute('data-src') || (source && source.getAttribute('src')) || '';
    if (!src) {
      video.remove();
      return;
    }
    if (source) source.src = src;
    else video.src = src;
    var play = function () { video.classList.add('epp-playing'); };
    video.addEventListener('canplay', play, { once: true });
    video.addEventListener('playing', play, { once: true });
    var p = video.play();
    if (p && typeof p.catch === 'function') p.catch(function () {});
  }

  function boot(root) {
    initReveal(root);
    initHeroVideo(root);
  }

  function bootAll() {
    document.querySelectorAll('.epp-wrap').forEach(boot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootAll);
  } else {
    bootAll();
  }
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target && e.target.querySelector('.epp-wrap');
    if (root) boot(root);
  });
})();
